/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import { Map, List, fromJS } from 'immutable';
import { denormalize } from 'normalizr';
import * as schemas from 'data/utils/schemas';
import { itemsPagination, listLoadingProgress } from 'data/reducers/wechat-invite-tokens';

import createImmutableEqualSelector from 'data/utils/immutable-selector';

const getState = (state) => state.wechatInviteTokens;

export const getEntities = (state) => getState(state).get('entities');

export const getWechatInviteTokensList = createImmutableEqualSelector([getEntities, getState], (entities, state) => {
  const pageItems = itemsPagination.getPageItems(state);

  if (pageItems && pageItems.size > 0) {
    return denormalize(pageItems, [schemas.wechatInviteToken], new Map({ wechatInviteTokens: entities }));
  }

  return List();
});

export const getWechatInviteTokensLoaded = (state) => listLoadingProgress.getLoaded(getState(state));
export const getWechatInviteTokensLoading = (state) => listLoadingProgress.getLoading(getState(state));
export const getWechatInviteTokensError = (state) => listLoadingProgress.getLoadFailed(getState(state));

export const getWechatInviteTokenByKey = createImmutableEqualSelector(
  [getWechatInviteTokensList, (state, key) => key],
  (tokens, key) => tokens.find((token) => token.get('key') === key),
);
